import React, { useState, useEffect } from 'react';
import PaymentSelection from './PaymentSelection';
import { toast } from 'react-toastify';
import API from '../../pages/Api';

const PaymentPage = ({ selectedCourses, eventDetails, onBack, userInfo }) => {
    const [showPaymentOptions, setShowPaymentOptions] = useState(false);
    const [exchangeRate, setExchangeRate] = useState(0.012); // Default rate (1 INR = 0.012 USD)

    
    useEffect(() => {
        const fetchDollarRate = async () => {
            try {
                const response = await API.get('get-dollar-rate/');
                const data = response.data;
                if (data && data.rate) {
                    setExchangeRate(data.rate);
                }
            } catch (error) {
                console.error("Error fetching dollar rate:", error);
            }
        };
        fetchDollarRate();
    }, []);

    const isEvent = !!eventDetails;
    const items = isEvent ? [eventDetails] : selectedCourses;

    
    const totalFeesINR = items.reduce((sum, item) => sum + parseFloat(item.f || item.price || 0), 0).toFixed(2);
    
    
    const totalFeesUSD = isEvent 
        ? (totalFeesINR * exchangeRate).toFixed(2) 
        : items.reduce((sum, item) => sum + parseFloat(item.amountDollar || 0), 0).toFixed(2);
    
    const userName = userInfo?.name || localStorage.getItem('userName') || "User";

    const handleMakePaymentClick = () => {
        setShowPaymentOptions(true);
    };

    const processPayment = async (method) => {

        try {

            toast.info(
                `Redirecting to ${method.toUpperCase()} gateway...`
            );

            // payment success

            toast.success(
                "Your event booking has been confirmed successfully."
            );

            setTimeout(() => {

                window.location.href =
                    "/TGSH/user/dashboard";

            }, 2000);

        } catch (error) {

            toast.error(
                "Payment failed. Please try again."
            );

        }
    };

    return (
        <div className="p-3 animate-in fade-in duration-500">
            <h2 className="text-[#02205c] font-bold text-[18px] mb-4">
                {isEvent ? "Event Booking Payment" : "Course And Payment Details"}
            </h2>
            
            <div className="border-[5px] border-[#02205c] p-2 bg-white rounded-sm shadow-md">
                <div className="mb-6">
                    <p className="font-bold text-gray-800 mb-4">Hi, {userName}</p>
                    <p className="text-gray-700 leading-relaxed text-[15px]">
                        Welcome to "THE GLOBAL SCHOOL OF HAPPINESS". 
                        {isEvent ? " Proceed to book your spot for the upcoming event." : " We are committed to spread happiness across the globe."}
                    </p>
                </div>

                <div className="mt-8">
                    <h3 className="text-center font-bold text-[16px] mb-3 uppercase tracking-wide">
                        {isEvent ? "Event Details" : "Your Selected Courses"}
                    </h3>
                    
                    <div className="overflow-x-auto">
                        <table className="w-full border-collapse border border-gray-200 text-[13px]">
                            <thead>
                                <tr className="bg-blue-950 text-white">
                                    <th className="border border-gray-300 p-2 text-center w-[40%]">NAME</th>
                                    <th className="border border-gray-300 p-2 text-center w-[20%]">{isEvent ? "VENUE" : "DURATION"}</th>
                                    <th className="border border-gray-300 p-2 text-center w-[20%]">FEE (INR)</th>
                                    <th className="border border-gray-300 p-2 text-center w-[20%]">FEE (USD)</th>
                                </tr>
                            </thead>
                            <tbody>
                                {items.map((item, index) => {
                                    const itemPriceINR = parseFloat(item.f || item.price || 0);
                                   
                                    const itemPriceUSD = isEvent 
                                        ? (itemPriceINR * exchangeRate).toFixed(2) 
                                        : parseFloat(item.amountDollar || 0).toFixed(2);

                                    return (
                                        <tr key={index} className="hover:bg-gray-50">
                                            <td className="border border-gray-300 p-2.5 pl-4 font-bold">{item.name || item.eventname}</td>
                                            <td className="border border-gray-300 p-2.5 text-center">{isEvent ? item.venue : `${item.d} Days`}</td>
                                            <td className="border border-gray-300 p-2.5 text-right pr-6 font-bold text-gray-700">₹{itemPriceINR.toFixed(2)}</td>
                                            <td className="border border-gray-300 p-2.5 text-right pr-6 font-bold text-green-700">${itemPriceUSD}</td>
                                        </tr>
                                    );
                                })}
                                <tr className="bg-gray-100 font-bold">
                                    <td colSpan="2" className="border border-gray-300 p-2.5 text-right pr-4">TOTAL</td>
                                    <td className="border border-gray-300 p-2.5 text-right pr-6 text-blue-800">₹{totalFeesINR}</td>
                                    <td className="border border-gray-300 p-2.5 text-right pr-6 text-green-800">${totalFeesUSD}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="mt-8 mb-6 flex flex-col items-center">
                    <h3 className="text-[#032167] font-bold text-[18px] mb-6">
                        Please Make Payment to Confirm
                    </h3>
                    
                    <button 
                        onClick={handleMakePaymentClick}
                        className="bg-[#032167] text-white px-8 py-2 text-[14px] uppercase font-semibold shadow-sm cursor-pointer hover:bg-[#052b86] border-none"
                    >
                        Make Payment
                    </button>
                    
                    <button 
                        onClick={onBack} 
                        className="text-blue-600 text-[12px] underline hover:text-blue-800 mt-4 cursor-pointer bg-transparent border-none"
                    >
                        Go Back
                    </button>
                </div>
            </div>

            {showPaymentOptions && (
                <PaymentSelection 
                    totalAmount={totalFeesINR} 
                    onClose={() => setShowPaymentOptions(false)} 
                    onProceed={processPayment} 
                    userInfo={userInfo} 
                    selectedCourses={items} 
                    isEvent={isEvent}        
                   
                    eventId={isEvent ? items[0].id : null} 
                />
            )}
        </div>
    );
};

export default PaymentPage;